module.exports = __webpack_public_path__ + "static/media/Pin_Job_Tow_Large.4b45432e.svg";